import React from "react";
import Nav from "../components/Nav";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebookF,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";

export default function ProfileSection() {
  return (
    <div className="hero-bg">
      <Nav />
      <div className="hidden lg:flex flex-col items-center space-y-6 fixed right-24 top-[75%] -translate-y-1/2 z-50">
        {/* Social Icons */}
        <ul className="flex flex-col space-y-4">
          <li>
            <a
              href="https://www.facebook.com/people/Track-Itt-Verified/61558262340147/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full text-gray-100  border hover:bg-red-600 hover:text-white hover:border-red-500 transition duration-300"
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/trackit_verified/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full text-gray-100  border hover:bg-red-600 hover:text-white hover:border-red-500 transition duration-300"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </li>
          <li>
            <a
              href="https://x.com/trackitsports"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full text-gray-100  border hover:bg-red-600 hover:text-white hover:border-red-500 transition duration-300"
            >
              <FontAwesomeIcon icon={faXTwitter} />
            </a>
          </li>
        </ul>

        {/* Vertical Text */}
        <span className="text-xs tracking-widest uppercase rotate-180 [writing-mode:vertical-rl] text-gray-300">
          Follow Us
        </span>
      </div>
      <div className="mx-auto my-auto text-center flex flex-col">
        <div className="text-outline text-white pb-2 text-5xl font-bold text-center mb-4 mt-8 sm:text-8xl">
          The Official Combine
        </div>
        <span className=" uppercase text-4xl text-red-500 mb-4 sm:text-7xl">
          For High School Athletes
        </span>
        <span className="flex items-center justify-center space-x-2">
          <span className="h-px bg-gray-400 w-28 sm:w-60"></span>
          <span className="font-normal text-red-500 uppercase text-md sm:text-2xl">
            {" "}
            Get verified{" "}
          </span>
          <span className="h-px bg-gray-400 w-28 sm:w-60"></span>
        </span>
        <span className="text-white uppercase mt-4 mb-6 font-normal text-xl sm:text-2xl">
          Test, impress, and get seen by recruiters.
        </span>
        <div className="mt-4">
          <Link
            to={"/events"}
            className="bg-red-500 text-white px-12 py-3 rounded-full uppercase "
          >
            Register for events
          </Link>
        </div>
      </div>
    </div>
  );
}
